import deletedIllustration from '#src/pages/group/deleted_group_card/assets/shredder.png';
import { emailTemplateToHref, HELP_EMAIL_ADDRESS } from '#src/pages/group/support/support_email.ts';
import { Anchor } from '@packages/ui/base/anchor/anchor';
import { AnchorAsButton } from '@packages/ui/base/button/anchor_as_button';
import { Card } from '@packages/ui/base/card/card';

export interface DeletedGroupCardProps {
  /** Absolute link to this group, included in the support email. */
  groupUrl: string;
  createGroupHref: string;
}

export const DeletedGroupCard = ({ groupUrl, createGroupHref }: DeletedGroupCardProps) => {
  return (
    <Card
      data-testid="deleted-group-page"
      className="flex max-h-full max-w-xl flex-col items-center overflow-hidden text-center"
    >
      {/* Illustration */}
      <img
        src={deletedIllustration}
        alt="Cute shredder and clock, representing a deleted Secret Santa group after 14 months."
        className="size-40 rounded-sm"
      />

      {/* Header */}
      <div className="flex flex-col items-center gap-4 pt-6">
        {/* Title */}
        <h1 className="text-2xl font-bold text-balance">
          This secret santa is no longer available
        </h1>
        {/* Explanation */}
        <div className="text-muted-foreground max-w-lg text-balance">
          To protect your privacy, we delete secret santa groups older than 14 months. Think this is
          a mistake? Contact us at{' '}
          <Anchor
            href={getMailToHref(groupUrl)}
            target="_blank"
            rel="noopener noreferrer"
            className="text-muted-foreground"
          >
            help@draw.name
          </Anchor>
          .
        </div>
      </div>

      {/* Create CTA */}
      <div className="flex flex-col items-center gap-3 pt-10">
        <AnchorAsButton href={createGroupHref} variant="primary">
          <span>Create a new secret santa</span>
        </AnchorAsButton>
        <Anchor href="/" className="text-sm">
          Go home
        </Anchor>
      </div>
    </Card>
  );
};

const getMailToHref = (groupUrl: string) =>
  emailTemplateToHref({
    to: HELP_EMAIL_ADDRESS,
    subject: 'Deleted Secret Santa Group',
    body: [
      'Hey,',
      '',
      'My secret santa group appears to have been deleted, but I believe it should still be available.',
      `Here is the link to the group: ${groupUrl}`,
      '',
      'Thanks!',
    ].join('\n'),
  });
